import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spring } from 'react-spring';
import Swal from 'sweetalert2';

import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import Footer from '../../components/Footer/footer';
import EditImage from '../../static/images/edit.svg';
import DeleteImage from '../../static/images/delete.svg';
import '../../static/css/styles.css';
import { WhitelabelActions, alertActions } from '../../store/actions';
import { constants } from '../../Constants';
import { API_ROOT_URL } from '../../config';
import { history } from '../../helpers/history';
import { whitelabel } from '../../store/reducers/whitelabel.reducer';
import ReactTooltip from 'react-tooltip';
import wellbeingIcon from "../../static/images/wellbeing.svg";
import nutritionistIcon from "../../static/images/nutrionist.svg";
import { sortByDateCreated } from '../../helpers/utils';

class Projects extends Component {
	constructor(props) {
		super(props);
		this.state = {
			projects: [],
			loading: false,
		};
	}

	toggleLoading = (status) => {
		this.setState({ loading: status });
	};
	componentWillMount() {
		this.toggleLoading(true);
		this.props.fetchWhitelabel();
	}

	componentWillReceiveProps(nextProps) {
		const { projects } = this.state;
		if (!!nextProps && nextProps.whitelabel)
			if (projects !== nextProps.whitelabel) {
				this.setState({ projects: nextProps.whitelabel, loading: false });
			}
	}

	deleteProject = () => {
		Swal.fire({
			title: constants.ARE_YOU_SURE_TXT,
			text: constants.DELETE_CONFIRMATION_MESSAGE_TXT,
			type: constants.WARNING_TXT,
			icon: constants.ERROR_TEXT,
			showCancelButton: true,
			reverseButtons: true,
			confirmButtonColor: '#36A692',
			cancelButtonColor: '#d33',
			cancelButtonText: constants.NO_TXT,
			confirmButtonText: constants.YES_TXT,
			footer: '<a href>Contact Administrator?</a>',
		});
	};

	editProject = (id) => {
		if (id !== '') this.props.selectWhitelabel(id);
		history.push('/update-project');
	};

	render() {
		const { projects, loading } = this.state;
		const { permissions_with_status } = this.props.user;

		if (loading) {
			return <Loading />;
		} else {
			const sortedProjects = sortByDateCreated(projects, "date_created");
			return (
				<div className="ContainerFix">
					<HeaderComponent />
					<Spring from={{ transform: 'translate(+100%, 0)' }} to={{ transform: 'translate(0%, 0)' }}>
						{(props) => (
							<div className="" style={props}>
								<div className="row mt-5 mx-auto w-75 pb-5" id="cardButtonContainer">
									<p className="lead heading-text">{constants.WHITELABELS_TXT}</p>
									<hr className="lead--heading-line" />
									{Array.isArray(sortedProjects) && sortedProjects.length > 0 ? (
										sortedProjects.map((p) => {
											return (
												<div className="card bg-light text-dark lead--card-heading">
													<div className="card-body m-2">
														<div className="row">
															<div className="col-md-2 col-sm-3 counsellor-img">
																<img
																	src={`${p.logo_url}`}
																	alt="Avatar"
																	className="avatar-counsellor counsellor-photo"
																	width="130px"
																	height="130px"
																/>
															</div>
															<div className="col-md- col-sm-6">
																<div className="d-flex flex-column flex-md-row service-tag-container">
																	{/* Name */}
																	<span className="card--list-name counsellor-project text-nowrap">
																		{p.name}
																	</span>
																	{/* Service Type Tags */}
																	{p.service_types && p.service_types.length > 0 && (
																		<div className='service-tag-conatiner'>
																			{p.service_types.map((type, index) => (
																				
																				<div key={index} className="d-flex align-items-center service-tag-inner-container counsellor-project">
																					<img
																						src={type.name === "Wellbeing" ? wellbeingIcon : nutritionistIcon}
																						className={`counsellor-image-icon ${type.name === 'Wellbeing' ? 'mr-1' : 'mr-015'}`}
																						width={type.name === 'Wellbeing' ? 14 : 20}
																						
																					/>
																					<span className='serive-tag-name-style'>
																						{type.name}
																					</span>
																				</div>
																			))}
																		</div>
																	)}
																</div>
																<div className="row counsellor-details">
																	<div className="col-md-13 col-sm-12">
																		<ul className="list-counsellor-details p-0">
																			<li>
																				{constants.DOMAIN_TXT}: {p.domain}
																			</li>
																			<li>
																				{constants.EMAIL_DOMAINS_TXT}:{' '}
																				{p.email_domain}
																			</li>
																			<li>
																				{constants.PAYMENT_TXT}:{' '}
																				{p.payment_required
																					? 'Required'
																					: 'Not required'}
																			</li>
																			{p.is_session_cap_allowed &&
																				<li>
																					{constants.TOTAL_SESSION_CAP_TXT}: {' '}
																					{p.total_session_cap}
																				</li>
																			}
																		</ul>
																	</div>
																</div>
															</div>
															<div className="col-3 counsellor-actions">
																<div className="card--icons-text counsellor-icons-text">
																	<a
																		className={`card--icon counsellor-card--icon ${
																			!permissions_with_status[
																				'project.change_project'
																			]
																				? 'disableCursor'
																				: ''
																			}`}
																		onClick={() => this.editProject(p.id)}
																		disabled={
																			!permissions_with_status[
																			'project.change_project'
																			]
																		}
																		data-tip
																		data-for="tooltip"
																		data-tip-disable={
																			permissions_with_status[
																			'project.change_project'
																			]
																		}
																	>
																		<img
																			className="card--image-icons"
																			src={EditImage}
																			alt="edit icon"
																		/>
																		<span className="card--ico-text">
																			{constants.EDIT_TXT}
																		</span>
																	</a>
																	<a
																		className={`card--icon counsellor-card--icon m-0 ${
																			!permissions_with_status[
																				'project.delete_project'
																			]
																				? 'disableCursor'
																				: ''
																			}`}
																		onClick={() => this.deleteProject}
																		disabled={
																			!permissions_with_status[
																			'project.delete_project'
																			]
																		}
																		data-tip
																		data-for="tooltip"
																		data-tip-disable={
																			permissions_with_status[
																			'project.delete_project'
																			]
																		}
																	>
																		<img
																			className="card--image-icons"
																			src={DeleteImage}
																			alt="delete icon"
																		/>
																		<span className="card--ico-text">
																			{constants.DELETE_TXT}
																		</span>
																	</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											);
										})
									) : (
										<h4>{constants.NO_WHITELABELS_TXT} </h4>
									)}
									<ReactTooltip id="tooltip" effect="solid">
										<div className="disabledTooltip" id="divSessionTooltip">
											<span>{constants.PERMISSIONS_TXT}</span>
										</div>
									</ReactTooltip>
								</div>
							</div>
						)}
					</Spring>
					<Footer />
				</div>
			);
		}
	}
}
function mapStateToProps(state) {
	const { auth, alert } = state;
	const { user } = auth;

	const authstate = state.auth;
	const { whitelabel } = state.whitelabel;

	return {
		alert,
		user,
		authstate,
		whitelabel,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
		selectWhitelabel: (id) => {
			dispatch(WhitelabelActions.selectWhitelabel(id));
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Projects));



// WEBPACK FOOTER //
// ./src/screens/Projects/index.js